import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { endPoints } from "../../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import PageHeader from "../../../components/PageHeader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";

import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import DeleteModel from "../../../components/DeleteModel";
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const FeatureGames = () => {

  const [editData, setEditData] = useState({
  });
  const [createData, setCreateData] = useState(false);
  const [rowDataToDelete, setRowDataToDelete] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [providerName, setProvideName] = useState("");
  const [providerList, setProviderList] = useState([])
  const [gameList, setGameList] = useState([])

  const [gameName, setGameName] = useState("");
  const [menuSort, setMenuSort] = useState("");
  const [checkboxes, setCheckboxes] = useState({
    isCheckedActive: false,
  });
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: checked,
    }));
  };

  const [pending, setPending] = useState(true);
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    // api call
    featureGameList();
    fetchProviderList();

  }, []);

  const featureGameList = async () => {
    let url = `${endPoints.api.GETFEATUREGAMES}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);

          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };
  const fetchProviderList = async () => {
    let url = `${endPoints.api.GETPROVIDERS}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setProviderList(response.data);

        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };
  const handleProviderChange = (event) => {
    fetchGameList(event)
  }
  const fetchGameList = async (provider_name) => {
    let url = `${endPoints.api.GAMES_BY_PROVIDER}${provider_name}`;
    await getAllData(url)
      .then((response) => {
        if (response.status === "success") {
          setGameList(response.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleOk = () => {

    if (providerName && gameName && menuSort) {
      let url = editData?.id
        ? `${endPoints.api.UPDATE_FEATUREGAMES}`
        : `${endPoints.api.ADD_FEATUREGAMES}`;


      let payload = {
        provider: providerName,
        // game_name: gameName,
        game_id: gameName,
        menu_sort_order: menuSort,
        isactive: checkboxes.isCheckedActive ? 1 : 0,

      };
      if (editData?.id) {
        payload.id = editData.id;
      }
      setIsLoading(true);
      addData(url, payload)
        .then((response) => {
          setIsLoading(false);
          if (response.data.status === "success") {
            SuccesToast(response?.data?.message);
            featureGameList();
            // console.log(response);
            handleClose();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          ErrorToast(error);
        });
    }
    else {
      ErrorToast("all fields are required");
    }
  };

  useEffect(() => {
    if (editData) {
      setProvideName(editData.provider || '');
      setGameName(editData.game_id || '');
      setMenuSort(editData.menu_sort_order || '');
      setCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        isCheckedActive: (editData.isactive || false),
      }));
    }
  }, [editData]);


  const handleDelete = (row) => {
    setRowDataToDelete(row);
    setShowDeleteModal(true);
  };

  const deleteFeatureGames = () => {

    const id = rowDataToDelete.id;

    let url = `${endPoints.api.DELETE_FEATUREGAMES}${id}`;
    setIsLoading(false);
    deleteData(url)
      .then((response) => {

        setIsLoading(false);
        if (response.status == 200) {
          setShowDeleteModal(false);
          featureGameList();
          SuccesToast("Deleted Successfully")

        } else {
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  }

  const handleSwitchChange = (row, param, value) => {

    const updatedRow = { ...row, [param]: value === 0 ? 1 : 0 };
    updateFeatureGames(updatedRow)

  };

  const updateFeatureGames = (payload) => {

    const id = payload.id;
    let url = `${endPoints.api.UPDATE_FEATUREGAMES}`;
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          featureGameList();
          console.log(response);
          handleClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  }

  // FeatureGames Filter 
  const [filteredRows, setFilteredRows] = useState(rows);
  const [filterValue, setFilterValue] = useState('');

  const handleFilterChange = (event) => {
    const newFilterValue = event.target.value.toLowerCase();
    setFilterValue(newFilterValue);

    if (newFilterValue === "") {
      setFilteredRows(rows);
    } else {
      const filteredData = rows.filter(item =>
        item.provider.toLowerCase().includes(newFilterValue) ||
        item.game_name.toLowerCase().includes(newFilterValue)
      );
      setFilteredRows(filteredData);
    }
  };

  const rowsToDisplay = filterValue.length > 0 ? filteredRows : rows;


  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        <DeleteModel
          showModal={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onDelete={deleteFeatureGames}
        />
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <PageHeader title="Feature Games" crumb="Casino / Feature Games" />

              <div style={{ marginTop: "10px" }}>
                <div className="table_search">
                  <TextField
                    style={{ marginBottom: '10px', width: '25%' }}
                    placeholder="Enter  Provider or Game Name..."
                    type="text"
                    onChange={handleFilterChange}
                    value={filterValue}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}

                  />
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        aria-label="sticky table"
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Game ID</TableCell>
                            <TableCell align="center">Provider</TableCell>
                            <TableCell align="center">Game Name</TableCell>
                            {/* <TableCell align="center">Menu</TableCell> */}
                            {/* <TableCell align="center">30 Day Play</TableCell>
                            <TableCell align="center">Hold %</TableCell> */}
                            <TableCell align="center">Sort Order</TableCell>
                            <TableCell align="center">Active</TableCell>
                            <TableCell align="center">Options</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsToDisplay.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                            <TableRow
                              key={row.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="center">{row.id}</TableCell>
                              <TableCell align="center">
                                {row.provider}
                              </TableCell>
                              <TableCell align="center">{row.game_name}</TableCell>
                              {/* <TableCell align="center">{row.menu_sort_order}</TableCell> */}
                              {/* <TableCell align="center">{row.day}</TableCell>
                              <TableCell align="center">{row.hold}</TableCell> */}
                              <TableCell
                                align="center"
                                style={{ width: "20%" }}
                              >
                                <Form.Control value={row.menu_sort_order} />
                              </TableCell>
                              <TableCell align="center">
                                <Switch
                                  checked={row.isactive !== 0}
                                  onChange={() => handleSwitchChange(row, 'isactive', row.isactive)}
                                />
                              </TableCell>

                              <TableCell align="center">
                                <EditIcon onClick={() => {
                                  setShow(true);
                                  setCreateData(true);
                                  setEditData(row);
                                  fetchGameList(row.provider)

                                }}
                                  style={{ cursor: 'pointer' }}
                                />
                                <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => handleDelete(row)} />
                              </TableCell>
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                  <>
                    <Modal
                      show={show}
                      onHide={handleClose}
                      style={{ marginTop: "10%" }}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                          Manage Feature Games
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Provider Name </Form.Label>
                              <Form.Select value={providerName} onChange={(event) => {
                                setProvideName(event.target.value);
                                handleProviderChange(event.target.value);
                              }}>
                                <option value=''>Select Provider</option>

                                {providerList.map((item, index) => {
                                  return (
                                    <option value={item.provider_name}>{item.provider_name}</option>
                                  )
                                })
                                }
                              </Form.Select>
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Game Name </Form.Label>
                              <Form.Select value={gameName} onChange={(event) => {
                                setGameName(event.target.value);
                              }}>
                                <option value=''>Select Game Name</option>
                                {gameList.map((item, index) => {
                                  return (
                                    <option value={item.game_id}>{item.game_name}</option>
                                  )
                                })
                                }
                              </Form.Select>
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Menu Sort order</Form.Label>
                              <Form.Control type="number" placeholder="xxxxx" value={menuSort} onChange={(event) => {
                                setMenuSort(event.target.value);
                              }} />
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <FormGroup>
                              <FormControlLabel
                                style={{ marginTop: '30px' }}
                                control={<Checkbox
                                  name="isCheckedActive"
                                  checked={checkboxes.isCheckedActive}
                                  onChange={handleCheckboxChange}

                                />}
                                label="Active"
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={handleOk}
                          style={{
                            background: "#04631e",
                            borderColor: "#04631e",
                          }}
                        >
                          Apply
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: "20px",
                }}
              >
                <Button
                  variant="primary"
                  style={{ background: "#04631e", borderColor: "#04631e" }}
                  onClick={() => {
                    setShow(true);
                    setEditData({})
                    setCreateData(true);
                  }}
                >
                  Add New Feature Game
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeatureGames;
